import SkirtingBoards from "./SkirtingBoards";

export default SkirtingBoards;
